<template>
  <v-card>
    <v-card-title primary-title class="justify-center">
      <div>
        <div class="display-1 font-weight-medium blue--text">
          <v-icon large>help</v-icon>
          Creating Patients
        </div>
      </div>
    </v-card-title>
    <v-card-text>
      <v-stepper v-model="step" vertical non-linear>
        <v-stepper-step editable step="1">
          <span class="blue--text" @click="openPage('help-signin')">Sign in</span> and click on "Create" item under the "Patients" menu.
        </v-stepper-step>

        <v-stepper-content step="1">
          <v-card class="mb-5">
            <img src="~assets/images/help_patientcreate_1.png">
          </v-card>
          <v-btn color="primary" @click="step = 2">Continue</v-btn>
        </v-stepper-content>

        <v-stepper-step editable step="2">
          Fill out the Patient's details
          <small>
            "Full Name" and "Date of Birth" are the mandatory fields.
            <br>
            Define a Patient ID (max. 64 characters) or leave it blank, and the system will generate a new ID.
            <br>
            "MyOffspring ID" refers to a registration on another Althash DApp called <b>MyOffspring</b>, where it is possible register newborns and generate digital birth certificates. You can visit <a href="https://althash.org" target="_blank" style="text-decoration: none"><b>Althash Web Platform</b></a> to use MyOffspring.
            <br>
            If the patient has an ID on MyOffspring you can type it in this field so both records will be related.
          </small>
        </v-stepper-step>

        <v-stepper-content step="2">
          <v-card class="mb-5">
            <img src="~assets/images/help_patientcreate_2.png">
          </v-card>
          <v-btn color="primary" @click="step = 3">Continue</v-btn>
        </v-stepper-content>

        <v-stepper-step editable step="3">
          Confirm the transaction
          <small>
            If you haven't taken note of the Patient ID, please do so.
            <br>
            Click on "Copy" button and paste it somewhere safe.
            <br>
            Click on "Confirm" to send the registration transaction to Althash blockchain.
          </small>
        </v-stepper-step>

        <v-stepper-content step="3">
          <v-card class="mb-5">
            <img src="~assets/images/help_patientcreate_3.png">
          </v-card>
          <v-btn color="primary" @click="step = 4">Continue</v-btn>
        </v-stepper-content>

        <v-stepper-step editable step="4">
          Wait for the transaction to confirm
          <small>
            The Althash blockchain takes just a few minutes to confirm a transaction.
            <br>
            Wait for it to confirm.
          </small>
        </v-stepper-step>

        <v-stepper-content step="4">
          <v-card class="mb-5">
            <img src="~assets/images/help_patientcreate_4.png">
          </v-card>
          <v-btn color="primary" @click="step = 5">Continue</v-btn>
        </v-stepper-content>

        <v-stepper-step editable step="5">
          Patient created!
          <small>
            The transaction was confirmed. 
            <br>
            You can click on "Open patient" button to open a window with Patient Info.
          </small>
        </v-stepper-step>

        <v-stepper-content step="5">
          <v-card class="mb-5">
            <img src="~assets/images/help_patientcreate_5.png">
          </v-card>
          <v-btn color="primary" @click="step = 6">Continue</v-btn>
        </v-stepper-content>

        <v-stepper-step editable step="6">
          Patient Info
          <small>
            You can print this window and hand it to the Patient so they can keep their QRCode.
            <br>
            With their QRCode they can be easily found in the system whenever they return.
          </small>
        </v-stepper-step>

        <v-stepper-content step="6">
          <v-card class="mb-5">
            <img src="~assets/images/help_patientcreate_6.png">
          </v-card>
          <v-btn color="primary" @click="step = 1">Back to start</v-btn>
          <v-btn flat @click="openPage('help')">Back to help</v-btn>
        </v-stepper-content>

      </v-stepper>
    </v-card-text>
  </v-card>
</template>

<style>
  .cursor:hover{
    cursor: pointer;
  }
</style>

<script>
export default {
  props: ['localUserType'],
  data () {
    return {
      localUserType: this.localUserType,
      step: 1
    }
  },
  methods: {
    openPage(name) {
      this.$emit("openPage", name);
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/controllers/Help-Patientcreate.vue